/**
 * El enlace para escribirle a alguien por WhatsApp, con el mensaje puesto.
 *
 * `https://wa.me/<número>?text=<mensaje>` es el enlace oficial y funciona en
 * los tres lados sin cambiar nada: abre la aplicación en el teléfono y
 * WhatsApp Web en la computadora. NO MANDA NADA: deja el mensaje escrito en
 * la conversación para que la persona lo lea, lo corrija y le dé enviar.
 * Escribir por alguien sin que lo vea sería otra cosa.
 *
 * EL NÚMERO VA SIN `+` NI ESPACIOS. Es lo que pide `wa.me`, y es la parte que
 * se equivoca sola: un número guardado como «+506 8888-7777» arma un enlace
 * que abre WhatsApp sin conversación, y se ve como que el botón no sirve.
 */
export function whatsappHref(phone: string, message = ''): string | null {
  const dígitos = phone.replace(/\D/g, '');
  // Un número de menos de ocho dígitos no es un teléfono: es un dato malo o
  // un campo a medio llenar, y mejor no ofrecer el enlace que abrir la nada.
  if (dígitos.length < 8) return null;
  // Sin mensaje, sin `?text=`: un `text` vacío abre la conversación con el
  // campo enfocado igual, pero deja una URL con basura al final.
  if (message === '') return `https://wa.me/${dígitos}`;
  return `https://wa.me/${dígitos}?text=${encodeURIComponent(message)}`;
}
